import { useCallback, useRef } from 'react';

import type { TEventProperties } from '../../../Analytics';
import { identifyAnalyticsUser } from '../../../Analytics';
import type { IColorUser } from '../../ColorUser';

export interface IUseIdentifySegmentUserResult {
  updateSegmentUser: (user: IColorUser | undefined, properties?: TEventProperties) => void;
}

export function useIdentifySegmentUser(): IUseIdentifySegmentUserResult {
  const lastUserIdRef = useRef('');
  const updateSegmentUser = useCallback(
    (user: IColorUser | undefined, properties: TEventProperties = {}): void => {
      const patientId = user?.patient_id;
      // Send a Segment identify() call only *once* for each user based on unique `patient_id`.
      if (patientId && patientId !== lastUserIdRef.current) {
        identifyAnalyticsUser({ patientId, isColorEmployee: user.is_color_employee, properties });
        lastUserIdRef.current = patientId;
      }
    },
    []
  );

  return { updateSegmentUser };
}
